// @ts-nocheck
import GoingUtils from "@/utils/goingUtils";
import {unref} from "vue";
import {getUrlParams, GoingNewUtils} from 'xmgoing-utils';
import {CurrentUtils} from "xmgoing-server";
import {
  _initStoreByConfig,
  _setStateRemarks
} from "@/main-page/utils/userStateUtils";
import {state} from "vue-tsc/out/shared";
import {useRoute} from "vue-router";
import {createDynamicStore} from "@/store/utils/dynamicStore";

interface PageModelsState {
  modulesList: [];
  pageList: [];
  inParams: [];
  state: {}; //全局对象
}

interface IFieldConfig {
  //实体识别名称
  entityKey: string;
  //字段识别名称
  key: string;
  modelObj?: any;
}

interface IModuleObj {
  name: string,
  entityKey: string,
  entitys: Array<any>,
}

export interface ICtlInfos {
  id: string,
  label: string,
  type: string,
}

/**
 * 根据字段类型获取默认值
 * @param fieldObj
 */
function getFieldDefValue(fieldObj) {
  if (fieldObj.type === 'string' || fieldObj.type === "xmInput") {
    return ''
  }
  return;
}

/**
 * 构建实体字段信息 默认值为空
 * @param moduleNewObj
 * @param entitys
 */
const getModuleFields = function (moduleNewObj, entitys) {
  entitys.forEach((fieldObj: any) => {
    if (fieldObj["value"]) {
      moduleNewObj[fieldObj.key] = fieldObj["value"];
    } else if (getFieldDefValue(fieldObj)) {
      moduleNewObj[fieldObj.key] = getFieldDefValue(fieldObj);
    }
  })
}

/**
 * 获取状态值
 * @param dataType
 * @param defValue
 */
function getVuexValue(dataType, defValue) {
  if (dataType === "boolean") {
    return GoingNewUtils.parseBoolean(defValue)
  }
  return defValue;
}

/**
 * 根据vuex里面的定义 获取其中的值
 * @param vuexStr
 */
export function getStateVuexVal(vuexStr) {
  window.vuex = unref(state);
  return eval(`${vuexStr}
  }`);
}

interface IStateItem {
  value: string,//状态的id
  label: string,//状态的描述
  defValue: any,//状态的值
  propType: string,
  dataType?: string,
  modelObj?: any,
  domainId?: string,
}

export const usePageModelsStore = function () {
  const route = useRoute();
  let storeId = route?.meta.storeId || GoingUtils.getPageCode();
  if (storeId == null || storeId === 'undefined') {
    storeId = "mainPageStore";
  }
  return createDynamicStore(
    {
      name: 'pageModels',
      state: () => ({
        loadUserTimer: null,
        bopConfigLoadTimer:null,
        modulesList: {},
        pageList: [],
        inParams: [], //入口参数
        events: [],
        //状态信息描述列表
        stateRemarks: [],
        tenantInfo: {
          isMoreTenant: false, //是否存在多租户
          tenantData: [], //租户数据
          tenantCode: '', //租户编码
          isFirst: true, //是否第一次进入
        },
        curPageId: '', //当前界面id
        firstPageId: '', //启始界面id
        prePageId: '', //前一个界面id
        //全局的状态信息
        state: {
          name: storeId,
        },
        models: [],
        pageCtls: {},//界面控件映射集合
        pageCtlsInfos: [],//界面控件描述串
      }),
      getters: {
        getPageCtls() {
          return this.pageCtls;
        },
        getPageCtlsInfos() {
          return this.pageCtlsInfos;
        },
        getStateRemarks() {
          return this.stateRemarks;
        },
        getState() {
          return this.state;
        }
      },
      actions: {
        setPropValue(propId, propValue) {
          this.state[propId] = propValue;
        },
        //清空历史参数
        clearState() {
          console.error("===========pageModels.ts.ts======")
          // 清理定时器
          if (this.loadUserTimer) {
            clearTimeout(this.loadUserTimer);
            this.loadUserTimer = null;
          }
          // 清理所有缓存数据
          this.models = [];
          this.state = {};
          this.pageCtls = {};
          this.pageCtlsInfos = [];
          this.modulesList = {};
          this.events = [];
        },
        clearStateRemarks() {
          this.stateRemarks = [];
        },
        //界面加载完后 加载用户定义的vuexRemarks;
        setPageStateByRemarks(vuexRemarks) {
          if (vuexRemarks && Array.isArray(vuexRemarks)) {
            this.stateRemarks = vuexRemarks;
            vuexRemarks.forEach((vuexItem) => {
              this.state[vuexItem.value] = getVuexValue(vuexItem.dataType, vuexItem.defValue);
            })
          }
        },
        getCtl(ctlId) {
          console.log(ctlId, "-----pageCtls---")
          console.log(this.pageCtls, "-----pageCtls---")
          return this.pageCtls[ctlId];
        },
        /**
         * 新增控件 到控件池
         * @param ctlInfos
         * @param ctlObj
         */
        addCtl(ctlInfos: ICtlInfos, ctlObj) {
          const {id} = ctlInfos;
          this.pageCtlsInfos.push(ctlInfos);
          this.pageCtls[id] = ctlObj;
        },
        /**
         * 删除控件 从控件池移除相应组件
         * @param curPageId
         */
        removeCtl(ctlItem) {
          const {_vid} = ctlItem;
          let indexDel = -1;
          //查找需要删除的元素
          this.pageCtlsInfos.forEach((dbItem, index) => {
            if (dbItem.id === _vid) {
              indexDel = index;
            }
          })
          if (indexDel >= 0) {
            this.pageCtlsInfos.splice(indexDel, 1)
          }
        },
        initStoreByConfig(pageModelsStore, pageConfigs, initState = true) {
          //如果存在state信息 则需要赋值到平台
          if (initState) {
            pageModelsStore.setState({});
          }
          //设置缓存的状态
          if (unref(pageConfigs).state) {
            _initStoreByConfig({pageConfigs, pageModelsStore, initState});
          }
          //设置缓存的全局事件
          if (unref(pageConfigs).evetns) {
            pageModelsStore.setEvents(unref(pageConfigs).evetns);
          }
          //设置缓存的状态描述
          if (unref(pageConfigs).stateRemarks) {
            pageModelsStore.setStateRemarks(unref(pageConfigs).stateRemarks, initState, initState === false ? 'subPageVuex' : '');
          }
          pageModelsStore.state.imgCheckError = false;
        },
        /**
         * 新增事件
         * @param eventItem
         */
        addEvent(eventItem) {
          this.events.push(eventItem);
        },
        /**
         * 修改事件
         * @param eventItem
         */
        modEvent(eventItem) {
          const newEvents = [];
          this.events?.forEach((dbEvent) => {
            if (dbEvent.elId === eventItem.elId) {
              dbEvent = {...dbEvent, ...eventItem};
            }
            newEvents.push(dbEvent);
          });
          this.events = newEvents;
          console.log(this.events, '=======dbEvent=====')
        },
        /**
         * 设置状态信息
         * @param stateJson
         */
        setState(stateJson, initState, fromType) {
          if (initState === false) {
            if (typeof (stateJson) === 'object') {
              Object.keys(stateJson).forEach((propName) => {
                if (fromType === 'parentVuex') {
                  this.state[propName] = stateJson[propName];
                } else {
                  if (!this.state[propName]) {
                    this.state[propName] = stateJson[propName];
                  }
                }
              })
            }
          } else {
            this.state = {...stateJson};
          }
          const moduleCode = getUrlParams("moduleCode", true);
          if (moduleCode?.indexOf("barCode_") >= 0) {
            this.state['drawerDesIdStr'] = true;
          }
        },
        setEvents(events) {
          this.events = [...events];
          // jsParse.initPagelEvents(this.events);
        },
        initAsyncState() {
          if (this.loadUserTimer) {
            clearTimeout(this.loadUserTimer);
          }
          try {
            this.loadUserTimer = setTimeout(() => {
              if (!this.state['currentUserInfo']) {
                CurrentUtils._loadUser(false, (userJson) => {
                  this.state['currentUserInfo'] = userJson;
                  this.state['currentTenantId'] = userJson['tenantId'];
                  this.state['curNotChangeTenantId'] = userJson['tenantId'];
                })
              }
            }, 500)
          } catch (e) {

          }
        },
        /**
         * 初始化 Bop 配置
         */
        async initBopConfig() {
          if(this.bopConfigLoadTimer){
            clearTimeout(this.bopConfigLoadTimer);
          }
          try {
            // 动态导入避免循环依赖
            const {loadMesProConfigApi} = await import("@/api/domainApi/domainComApi");
            this.bopConfigLoadTimer = setTimeout(async () => {
              if(!this.state['bopConfig']){
                const res = await loadMesProConfigApi({});
                if (res && Object.keys(res).length > 0) {
                  this.state['bopConfig'] = res;
                }
              }
            }, 100)
          } catch (e) {
            console.error('加载 Bop 配置失败:', e);
          }
        },
        /**
         * 根据默认值来初始化
         * @param stateRemarks
         */
        initStateValues(stateRemarks) {
          this.initAsyncState();
          this.initBopConfig();
          stateRemarks.forEach((stateRemark) => {
            const {defValue, dataType, value, propType} = stateRemark;
            if ((defValue != null && defValue !== "") && propType !== "systemProp") {
              if (this.state[value] == null || this.state[value] === '') {
                if (dataType === 'boolean') {
                  this.state[value] = GoingNewUtils.parseBoolean(defValue);
                } else {
                  this.state[value] = defValue;
                }
              }
            }
          })
        },
        setStateRemarks(stateRemarks, initState, fromType) {
          _setStateRemarks({stateRemarks, initState, fromType}, this)
        },
        /**
         * 向state里面添加值
         */
        setStateValue({
                        value,
                        defValue,
                        ctlType,
                        modelObj
                      }: IStateItem) {
          const itemObj = this.stateRemarks.filter((dbItem) => {
            return dbItem.value === value;
          })[0];
          if (itemObj == null) {
            if (modelObj) {
              modelObj[value] = defValue;
            }
            if(ctlType==='xmForm'){
              this.stateRemarks.push({
                ctlType,
                value,
              });
            }
          }
        },
        /**
         * 删除相应的状态
         * @param propId
         */
        deleteState(propId) {
          delete this.state[propId];
        },
        //设置当前pageId
        setCurPageId(curPageId) {
          //存储前一个界面的pageId
          if (this.curPageId && this.curPageId !== "") {
            this.prePageId = this.curPageId;
          } else {
            this.firstPageId = curPageId;
          }
          this.curPageId = curPageId;
        },
        //新增page记录
        addPageObj(pageObj) {
          this.pageList.push(pageObj);
        },
        clearPageList() {
          this.pageList = [];
        },
        /**
         * 设置模型集合
         * [
         *  {
         *       "name": "cs",
         *       "key": "5aea2af3e2",
         *       "entitys": [
         *         {
         *           "key": "cs",
         *           "name": "cs",
         *           "type": "string",
         *           "value": "dd"
         *         },
         *         {
         *           "key": "cs2",
         *           "name": "cs",
         *           "type": "string",
         *           "value": "cc"
         *         }
         *       ]
         *     }
         * ]
         * @param modules
         */
        setModules(modules: Array<any>) {
          this.models = unref(modules);
          modules.forEach((moduleObj: IModuleObj) => {
            const moduleNewObj = {};
            getModuleFields(moduleNewObj, moduleObj.entitys)
            this.modulesList[moduleObj.key] = moduleNewObj;
          })
        },
        clearAllModules() {
          this.models = [];
          this.modulesList = {};
        },
        clearAllCache() {
          this.models = [];
          this.modulesList = {};
          this.state = {};
        },
        /**
         * 情况某个领域对象的值
         * @param id
         */
        clearModulesData(id: string) {
          const moduleObj = this.modulesList[id];
          if (moduleObj) {
            Object.keys(moduleObj).forEach((propName) => {
              moduleObj[propName] = "";
            })
          }
        },
        /**
         * 根据字段配置的数据源信息获取绑定的模型信息
         * @param fieldConfig
         */
        getModelObj(fieldConfig: IFieldConfig, trItem = {}) {
          //如果用户绑定了数据源 则去获取实体对象 返回给用户
          if (unref(fieldConfig) && unref(fieldConfig).entityKey) {
            //如果绑定的是变量对象
            if (unref(fieldConfig).entityKey === 'state') {
              return this.state;
            }
            if ((unref(fieldConfig).entityKey + '').indexOf('state.') >= 0) {
              const domainCode = unref(fieldConfig).entityKey.split(".")[1];
              if (this.state[domainCode] == null) {
                this.state[domainCode] = {};
              }
              return this.state[domainCode];
            }
            //如果是动态表格
            if (unref(fieldConfig).entityKey === 'trObj') {
              return trItem;
            }
            //如果绑定的是领域对象
            if (this.modulesList[fieldConfig.entityKey]) {
              return this.modulesList[fieldConfig.entityKey];
            }
            return this.state;
          } else {

            //如果用户没有设置数据源 则返回一个全局数据源给用户使用
            return this.state;
          }
        }
      },
    },
    storeId
  )
}
